<template>
  <div class="scroll-item room-list-item">

    <!-- <div class="room-list-header">房间列表</div> -->

    <div class="flex-box">
     
      <div class="header-list">
        <div class="header-room">
          <p @click="pClick(1)" :class="controlClass === 1 ? 'actives' : ''">{{ todayItem === 1 ? '今天' : '一'
          }}<br><span :class="controlClass === 1 ? 'actives1' : 'actives'">{{ weekDate[0] }}</span></p>
          <p @click="pClick(2)" :class="controlClass === 2 ? 'actives' : ''">{{ todayItem === 2 ? '今天' : '二'
          }}<br><span :class="controlClass === 2 ? 'actives1' : 'actives'">{{ weekDate[1] }}</span></p>
          <p @click="pClick(3)" :class="controlClass === 3 ? 'actives' : ''">{{ todayItem === 3 ? '今天' : '三'
          }}<br><span :class="controlClass === 3 ? 'actives1' : 'actives'">{{ weekDate[2] }}</span></p>
          <p @click="pClick(4)" :class="controlClass === 4 ? 'actives' : ''">{{ todayItem === 4 ? '今天' : '四'
          }}<br><span :class="controlClass === 4 ? 'actives1' : 'actives'">{{ weekDate[3] }}</span></p>
          <p @click="pClick(5)" :class="controlClass === 5 ? 'actives' : ''">{{ todayItem === 5 ? '今天' : '五'
          }}<br><span :class="controlClass === 5 ? 'actives1' : 'actives'">{{ weekDate[4] }}</span></p>
        </div>
     
        <div class="middleroom" v-if="finalResult.length > 0">
          <div v-for="item in finalResult[0].list" :key="item.id" class="room-lists" @click="selectList(item.id)">

            <div class="select-room">
              <div class="img-box">
                <div class="tops">
                  <span class="tops-item">{{ insertStr(item.intime, -2, ':') }}</span> 
                  <span class="tops-items">{{ insertStr(item.outime, -2, ':') }}结束</span>
                </div>
                <div class="middle">
                  <span class="middle-name">{{ item.broom.name }}</span><br />
                  <div class="middle-item">
                    <img :src="item.bclass.tavatar" alt="">
                    <span>{{ item.bclass.tname }}</span>

                  </div>
                </div>
                <div
                  :class="item.broom.isplay && roomInfo.parentID == item.id ? 'bottoms' : 'bottoms bottoms1'">
                  <img v-if="item.broom.isplay && roomInfo.parentID == item.id"
                    class="vector" src="../../assets/images/wap/Vector.png" alt="">
                  <span
                    v-if="item.broom.isplay && roomInfo.parentID == item.id ">直播中</span>
                  <span v-else @click.stop="handleEnterRoom({...item.broom, parentID: item.id})">
                    进入房间
                  </span>

                </div>

              </div>


            </div>
     
          </div>

        </div>
      </div>
    </div>
    <!-- 提示老师结束上播状态弹窗 -->
    <el-dialog title="提示" :visible.sync="onPlayObj.show" center width="400px" @close="handleCancelEvent">
      <p>
        您在<span class="onplay-room-name">{{ roomInfo.name }}</span>处于上播状态。您确定要下播吗？
      </p>
      <span slot="footer" class="dialog-footer">
        <button class="dialog-btn-common dialog-btn-cancel" @click.stop="handleCancelEvent">
          取 消
        </button>
        <button class="dialog-btn-common dialog-btn-sure" type="primary" @click.stop="handleRoomChange">
          确 定
        </button>
      </span>
    </el-dialog>
    <!-- <img class="closer" @click="closerRoomlist" src="../../assets/images/user-info-close.png" alt=""> -->
  </div>
</template>
<script>
import config from '../../config/index'
import { setSessionStorage, isReactNative, isAndroidNative, isIOSNative } from '@/utils/tools'
import { getTimetable } from '../../api/home'
export default {
  data() {
    return {
      roomImg: require('../../assets/images/room-img.png'),
      onPlayObj: {
        show: false
      },
      youkeData: {
        plats: [
          {
            id: '1'
          }
        ],
        signtype: '10',
        device: 'pc',
        nick: '游客',
        username: this.getCookie('UUID'),
        utype: 0,
      },
      conner: true,
      roomMsg: {},
      pagesInfo: {
        page: 0,
        size: 10
      },
      // 日期数组
      weekDate: [],
      controlClass: 1,//当前星期选中
      finalResult: [],//时间
      selectId: null,
      showWeelList: false,//直播课表
      todayItem: '',//周几
    }
  },
  created() {
    console.log('房间列表时间--------', this.getDateChange(1724860800000), this.getDateChange(1759161600000))
    setTimeout(() => {
      this.init()
      this.getWeek()
    }, 500);

  },
  mounted() {
    this.$store.commit('home/set_craigPlay', true);
    setTimeout(() => {
      this.$nextTick(() => {
        this.todayTimeTable();
      })
    }, 800);
  },
  computed: {

    isNativeApp() {
      return !!(isReactNative() || isAndroidNative('finish') || isIOSNative())
    },
    showRoomList() {
      return this.$store.state.home.showRoomList
    },
    roomList() {
      const list = this.$store.state.home.roomList;
      if (this.roomInfo.id) {
        list.forEach((element, i) => {
          if (element.id == this.roomInfo.id) {
            this.craigRoom = element;
            list.splice(i, 1);
          }
          return
        });
        list.unshift(this.craigRoom);
      }
      return list
    },

    roomInfo() {
      console.log('进入房间信息---', this.$store.state.home.roomInfo)
      return this.$store.state.home.roomInfo
    },
    userInfo() {
      return this.$store.state.login.userInfo
    },
    isplay() {
      return this.$store.state.home.isplay
    },
    defaultVideoInfo() {
      return this.$store.state.home.defaultVideoInfo
    },
    roomset() {
      return this.$store.state.home.roomset
    },
    socket() {
      return this.$store.state.home.socket
    },
    roomtid() {
      return this.$store.state.home.roomtid
    },
    ckplayerObject() {
      return this.$store.state.home.ckplayerObject
    },
    player() {
      return this.$store.state.home.player
    },
    // craig-newAdd
    teacherInfo() {
      return this.$store.state.home.teacherInfo
    },
    craigPlay() {
      return this.$store.state.home.craigPlay
    },
    livingInfo() {
      return this.$store.state.home.livingInfo
    },

  },
  watch: {
    '$store.state.home.craigPlay'(newVal) {
      if (newVal) {
        // craig--获取正在直播的房间列表
        this.getLiving();
      }
    },

    'livingInfo'(newVal) {
      if (newVal) {
        console.log('直播信息', newVal)
        if (!sessionStorage.getItem('livingKey') || !sessionStorage.getItem('userInfo')) {
          this.handleEnterRoom(newVal);
          sessionStorage.setItem('livingKey', true);
        }
      }
    },

  },
  methods: {
    enableLiveVideoAutoplay(player, retry = 0) {
      const video = document.querySelector('#ckplayerVideo video')
      if (!video) {
        if (retry < 20) {
          setTimeout(() => this.enableLiveVideoAutoplay(player, retry + 1), 100)
        }
        return
      }
      const unlockMuted = () => {
        video.muted = false
        video.defaultMuted = false
        video.removeAttribute('muted')
        if (video.volume === 0) {
          video.volume = 1
        }
        const playPromise = video.play && video.play()
        if (playPromise && playPromise.catch) {
          playPromise.catch(() => undefined)
        }
      }
      if (player && !player.__nativeMutePatched) {
        const videoEscMute = player.videoEscMute
        player.volumeTemp = 1
        player.videoEscMute = function () {
          if (typeof videoEscMute === 'function') {
            videoEscMute.call(player)
          }
          if (typeof player.changeVolume === 'function') {
            player.changeVolume(1)
          }
          unlockMuted()
        }
        player.__nativeMutePatched = true
      }
      if (!video.__nativeMutePatched) {
        video.addEventListener('volumechange', () => {
          if (!video.muted && video.volume === 0) {
            unlockMuted()
          }
        })
        video.__nativeMutePatched = true
      }
      video.muted = true
      video.defaultMuted = true
      video.volume = 0
      video.setAttribute('muted', 'muted')
      video.setAttribute('playsinline', '')
      video.setAttribute('webkit-playsinline', 'true')
      video.setAttribute('x-webkit-airplay', 'true')
      video.setAttribute('x5-video-player-type', 'h5')
      video.setAttribute('x5-video-orientation', 'portraint')
      const playPromise = video.play && video.play()
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => undefined)
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(parseInt(timestamp));
      let Year = date.getFullYear();
      let Moth = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      let Day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
      let Hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let Minute =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      return Hour + ':' + Minute
    },
    // 时间戳转时间
    getDateChange(date) {
      var t = new Date(date).toLocaleString();
      return t;
    },
    insertStr(source, start, newStr) {
      return String(source).slice(0, start) + newStr + String(source).slice(start)
    },
    // 获取课表接口
    init() {
      // 获取房间信息
      const options = {
        platid: 1,
        size: 10000,
        sort: 'day2week,asc',
      }
      getTimetable(options).then(res => {
        let lists = []
        if (res.content.length > 0) {
          res.content.forEach(item => {

            if (this.roomInfo.bclass) {
              if (item.bclass.id == this.roomInfo.bclass.id) {
                lists.push(item)
              }
            }
          })
          this.$store.commit('home/set_avatarinfo', lists[0])
          this.timeTableContent = this.getListGroupBy(res.content, 'day2week')
          this.todayTimeTable()

        }

      })
      // await this.$store.dispatch('home/getTimetable', option)
    },
    // 根据某一天日期，获取该日所在周的所有日期
    getWeek() {
      // 一天里一共的毫秒数
      let oneDayTime = 1000 * 60 * 60 * 24
      let today = new Date()
      // 若那一天是周末时，则强制赋值为7
      let todayDay = today.getDay() || 7
      let startDate = new Date(
        today.getTime() - oneDayTime * (todayDay - 1)
      )
      for (let i = 0; i < 7; i++) {
        let temp = new Date(startDate.getTime() + i * oneDayTime)
        let year = temp.getFullYear();
        let month = temp.getMonth() + 1;
        if (month < 10) {
          month = '0' + month;
        }
        let day = temp.getDate();
        if (day < 10) {
          day = '0' + day;
        }
        this.weekDate[i] = `${day}`
      }
      return this.weekDate;
    },
    // 点击选择哪一天
    pClick(attr) {
      switch (attr) {
        case 1:
          this.controlClass = 1;
          break
        case 2:
          this.controlClass = 2;
          break
        case 3:
          this.controlClass = 3;
          break
        case 4:
          this.controlClass = 4;
          break
        case 5:
          this.controlClass = 5;
          break
      };
      this.finalResult = [];
      this.timeTableContent.forEach(element => {

        if (element.day2week == attr ) {
          this.finalResult.push(element);
        }
      });
      console.log('课表數組---------', this.finalResult)

      this.finalResult[0].list.map((item,index)=>{
        console.log('周课表---------++++++', item)
        if (!item.broom.enabled){
          this.finalResult[0].list.splice(index,1)
        }
      })
      console.log('周课表---------', this.finalResult)

    },
    // 将后台返回的对象数组根据某个相同字段组成新的对象数组
    getListGroupBy(list, key) {

      var keysArr = list.map(item => item[key])
      var keys = [...new Set(keysArr)]
      var newList = keys.map(item => {
        return {
          [key]: item,
          list: list.filter(i => i[key] == item)
        }
      })
      return newList
    },
    // 页面刚进入，通过获取当天为星期几，获取相应的课表内容
    todayTimeTable() {
      if (this.timeTableContent && this.timeTableContent.length > 0) {
        const attr = new Date().getDay();
        this.todayItem = attr
        this.pClick(attr);
        this.timeTableContent.forEach(element => {
          if (element.day2week == attr) {
            this.finalResult.push(element);
          }
        });
        this.finalResult[0].list.map((item, index) => {
          console.log('周课表---------++++++', item)
          if (!item.broom.enabled) {
            this.finalResult[0].list.splice(index, 1)
          }
        })
      }

    },
    /**
     * 进入房间事件处理（两种情况）
     * 1、当前用户是讲师，并且处于上播状态
     * 2、当前用户是讲师但不在上播状态 || 当前用户是客服
     **/
    getCookie(name) {
      const strCookie = document.cookie
      const arrCookie = strCookie.split(';')
      for (let i = 0; i < arrCookie.length; i++) {
        const arr = arrCookie[i].split('=')
        if (arr[0].replace(/(^\s*)|(\s*$)/g, '') === name) {
          return arr[1]
        }
      }
      return ''
    },
    async handleEnterRoom(item) {
      // 没有登录直接提示用户登录
      if (item.param.Acc_Type !== 'tourist' && !this.userInfo.id) {
        this.$message({
          type: 'error',
          message: '请您登录后再进入房间'
        })
        return
      }
      if (!this.userInfo.id) {
        this.youkeData.nick = '游客' + this.youkeData.username.substring(this.youkeData.username.length - 4, this.youkeData.username.length)
        await this.$store.dispatch('home/youkeLogin', this.youkeData)
        this.$store.commit('home/set_dialogobj', { dialogVisible: false })
        // 登录成功获取房间列表
        this.$emit('loginSuccess')
      }
      if (this.userInfo.utype === 1 && this.isplay && this.userInfo.id === this.roomtid) {

        // 如果当前用户是讲师，但处于上播状态需要提示
        this.onPlayObj.show = true
        this.roomMsg = item
      }
      else {
        console.log('我是讲师没有上播');
        this.isplay ? this.socket.close() : '' // 如果没有在上播状态不需要断开socket
        this.$store.commit('home/set_roominfo', item)
        this.$store.commit('home/set_roomtid', item.bclass ? item.bclass.tId : item.tId ?item.tId:item.id)
        setSessionStorage('roomInfo', item)
        await this.$store.dispatch('home/getCurrentRoomUser', {
          broomid: this.roomInfo.id
        })

        // 连接socket
        // craig--新增链接逻辑，去掉游客的userid，如果没有登录，重新分发新的userid
        if (!this.userInfo.id) {
          if (sessionStorage.getItem('craigNewUserid')) {
            const params = {
              roomid: this.roomInfo.id,
              uid: sessionStorage.getItem('craigNewUserid')
            }
            this.$store.dispatch('home/socketInit', params)
          } else {
            const params = {
              roomid: this.roomInfo.id,
              uid: this.craigNewUserid()
            }
            sessionStorage.setItem('craigNewUserid', this.craigNewUserid())
            this.$store.dispatch('home/socketInit', params)
          }
        }
        // 获取当前房间的聊天记录
        await this.getRoomHistory()
        // 获取当前房间的在线用户
        await this.$store.dispatch('home/getCurrentRoomUser', {
          broomid: this.roomInfo.id
        })

        // 获取选中房间的视频流地址或者默认视频地址 设置视频流地址或者默认播放视频 isplay: true 直播中（设置视频流地址）  false 不在直播（设置默认视频地址）
        if (this.roomInfo.isplay) {
          console.log('正在直播中');
          console.log(item);
          this.$store.commit('home/set_ckplayerObject', { video: item.param.pcurl || item.isplay, live: true })
          // eslint-disable-next-line no-undef
          const player = new Ckplayer(this.isNativeApp
            ? Object.assign({}, this.ckplayerObject, {
              volume: 0,
              mobileAutoFull: false
            })
            : this.ckplayerObject)
          this.$store.commit('home/set_player', player)
          if (this.isNativeApp) {
            this.$nextTick(() => this.enableLiveVideoAutoplay(player))
          }
          // vue-video-player插件，暂时废弃该方法
          // this.$store.commit('home/set_videoPlayerConfig', { sources: [{ src: item.param.pcurl, type: 'application/x-mpegURL' }] })
        } else {
          console.log('没有直播，播放默认视频');
          const TheTime = new Date().getTime()
          if (((TheTime - item.param.stime1) > 0 && (TheTime - item.param.etime1) < 0) || ((TheTime - item.param.stime2) > 0 && (TheTime - item.param.etime2) < 0)) {
            // 获取默认视频信息(测试环境发现有些房间的默认播放视频的id为空，所以加了判断)
            item.param.efile_id ? await this.$store.dispatch('home/getRoomDefaultVideoInfo', { id: item.param.efile_id, type: 0 }) : ''
          }
        }
        // 获取管理平台对房间的设置
        await this.$store.dispatch('home/getDicts', { name: 'talk_set', mark: config.platid })
        // 最后关闭弹出层
        this.$store.commit('home/set_showroomlist', false)
        this.$store.commit('home/set_isplay', this.roomInfo.isplay)
        location.reload()
      }
    },

    // 获取反房间历史聊天记录
    async getRoomHistory() {
      const option = Object.assign({}, { broomid: this.roomInfo.id, scope: 2 }, this.pagesInfo, { size: this.roomset.pushnum, sort: 'ut,DESC' })
      const data = Object.assign({
        broomid: this.roomInfo.id,
        sort: 'ut,DESC',
        // 课程id
        // bsheetid:this.teacherInfo[0].value.id,
        stype: null,
        platid: 1,
        userid: this.userInfo.id
      })
      await this.$store.dispatch('home/getRoomHistoryChatRecord', data)
    },
    // 确定进入其他房间
    async handleRoomChange() {
      this.$store.commit('home/set_isplay', false)
      if (!this.isplay) {
        const nick = String(this.userInfo.mtaccr).replace(String(this.userInfo.mtaccr).substring(2, String(this.userInfo.mtaccr).length - 2), '****')
        // 讲师下播需要给socket发消息，通知客户端（APP和PC端）将房间的视频播放地址改为默认视频播放地址(在socket中修改地址)
        const option = {
          broomid: this.roomInfo.id,
          sname: this.userInfo.nick || nick,
          sid: this.userInfo.id,
          type: 16,
          param: {
            TXT: '老师直播结束了'
          }
        }
        this.socket.send(JSON.stringify(option))
        this.onPlayObj.show = false
        await this.handleEnterRoom(this.roomMsg)
        const params = {
          platid: config.platid,
          page: 0,
          size: 10
        }
        await this.$store.dispatch('home/getRoomList', params)
      }
    },
    handleCancelEvent() {
      this.onPlayObj.show = false
      this.$store.commit('home/set_showroomlist', false)
    },
    // craig--获取正在直播的房间列表
    async getLiving() {
      await this.$store.dispatch('home/getLiving', { platid: config.platid })
    },
    // 随机生成userid
    craigNewUserid() {
      let guid = ''
      for (let i = 1; i <= 32; i++) {
        const n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
      }
      return guid;
    },
    // 关闭roomlist
    closerRoomlist() {
      this.$store.commit('home/set_showroomlist', false);
    },
    selectList(id) {
      this.selectId = id
    }
  },
}
</script>
<style lang="less" scoped>
.room-list-item {
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 824px;
  max-height: 830px;
  border-radius: 5px;
  position: relative;

  .room-list-header {
    line-height: 38px;
    text-align: center;
    font-size: 16px;
    color: #000;
    border-bottom: 1px solid #dededd;
    background-color: #e6edf3;
  }

  .header-list {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    overflow-x: scroll;
  }

  .header-room {

    padding: 0 10px;
    box-sizing: border-box;
    height: 67px;
    background: #fff;
    color: #999;
    font-size: 12px;
    line-height: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f4f4f4;

    .active {
      color: #999;


    }

    ;

    .actives1 {
      background: #EE2547;
      width: 20px;
      height: 20px;
      display: inline-block;
      font-size: 12px;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 20px;
    }

    .actives {
      color: #000;
      font-weight: 600;
    }

    p {
      width: 34px;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-direction: column;
    }

  }

  .flex-box {
    display: flex;
    width: 100%;

  }

  .middleroom {
    font-size: 14px;
    line-height: 19px;
    color: #444;

    .room-lists {
      display: flex;
      flex-direction: column;
    }

    .room-tops {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 20px 0 16px;

      margin-bottom: 25px;

      .botts {
        font-size: 13px;
      }
    }

    .flex {
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
    }

    .select-room {
      padding: 12px 20px 12px 16px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      overflow-x: auto;
      border-bottom: 1px solid #f4f4f4;
      img {
        width: 50px;
        height: 50px;
        border-radius: 10px;
      }

      .img-box {
        background: #ffffff;
        border-radius: 8px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .tops {
          display: flex;
          align-items: center;
          flex-direction: column;
          &-item {
            color: #333;
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 7px;
          }

          &-items {
            color: #777;
            font-size: 12px;
          }
        }

        .middle {
          &-name {
            font-size: 14px;
            color: #333;
            font-weight: 600;
          }

          &-item {
            display: flex;
            align-items: center;
            margin-top: 6px;

            img {
              width: 20px;
              height: 20px;
              margin-right: 6px;
            }

            font-size: 11px;
            color: #777;

          }
        }

        .bottoms {
          width: 56px;
          height: 21px;
          background: #EE2547;
          border-radius: 20px;
          font-size: 10px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;

          .vector {
            width: 10px;
            height: 10px;
            margin-right: 6px;
          }
        }

        .bottoms1 {
          background: #2569EE;
        }
      }

      .img-bott {
        background: #2C3EB9CC;
        width: 50px;
        height: 18px;
        border-radius: 0 0 8px 8px;
        box-sizing: border-box;
        position: absolute;
        left: 0;
        bottom: 2px;
        font-size: 9px;
        line-height: 14px;
        color: #ffffff;
        text-align: center;
      }

      .flex-box {
        display: flex;
        flex-direction: column;
      }

      .txt {
        color: #2F3765;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        white-space: nowrap;
      }

      .txts {
        color: #2C3EB9;
        font-size: 12px;
        line-height: 18px;
        margin-top: 10px;
      }


    }

   
  }

  .room-item-section {
    box-sizing: border-box;
    padding: 0 0 0 10px;

    .room-item {
      height: auto;
      position: relative;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box;
      margin-bottom: 20px;
      width: 160px;

      .room-item-img {
        width: 100%;
        height: 146px;
        border-radius: 5px;
      }

      .roomBox {
        position: absolute;
        bottom: 10px;
        right: 49%;
        z-index: 3;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 8px auto 5px;

        .goin-home {
          width: 80px;
          line-height: 22px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          // border: 1px solid #ee2546;
          background: none;
          color: #ee2546;
          color: #fff;
          border-radius: 6px;
          background: #2C3EB9;
        }

        .room-name {
          max-width: 140px;
          font-size: 10px;
          // color: #333333;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .current-room {
          width: 78px;
          line-height: 20px;
          font-size: 14px;
          border: 1px solid #999999;
          background: none;
          color: #999999;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .fels {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .room-name {
          font-size: 10px;
        }
      }

      .roomHead {
        position: absolute;
        top: 10%;
        left: 10px;
        width: 93%;
      }

      .room-info {
        overflow: hidden;
        position: relative;
        z-index: 2;
        padding: 0 10px;
        display: flex;
        align-items: center;
        padding: 4px;
        background: #FE2C55;
        border-radius: 4px;
        color: #fff;
        font-size: 10px;

        button {
          width: 70px;
          height: 26px;
          line-height: 26px;
          border-radius: 13px;
          background: #d6a41f;
          color: #ffffff;
          float: right;
          cursor: pointer;
        }

        .room-living {
          float: right;
          font-size: 12px;
          color: #ee2546;
          color: #fff;

          // margin-bottom: 5px;
          img {
            vertical-align: middle;
            display: inline-block;
            width: 15px;
            height: auto;
          }
        }
      }

      .room-infos {
        background: #85858599;
      }
    }
  }

  .onplay-room-name {
    font-size: 14px;
    color: #3498db;
  }

  .dialog-btn-common {
    border: none;
    outline: none;
    font-size: 14px;
    cursor: pointer;
    border-radius: 6px;
    width: 80px;
    height: 34px;
  }

  .dialog-btn-cancel {
    border: 1px solid #dededd;
    color: #464852;
    margin-right: 15px;
  }

  .dialog-btn-sure {
    background: #3498db;
    color: #ffffff;
  }

  .closer {
    width: 15px;
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
